// ConnectedUserMenu
import ClassNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';

import DomUserPicture from './DomUserPicture';
import { getTranslator } from '../locales';
import { closeUI, EndTheChat } from '../redux/actions/chatInitAction';
import { notification } from '../redux/actions/alertAction';
import { toggleMenu } from '../redux/actions/luserAction';


@connect((Store) => {
  const t = getTranslator();

  return {
    labels: {
      ARE_YOU_SURE_CLOSE_THE_CHAT: t.t('This will disconnect all participants and end the chat. This cannot be undone - are you sure?'),
      ARE_YOU_SURE_LEAVE: t.t('Are you sure you want to leave the chat?'),
      CHAT_HAS_BEEN_CLOSED: t.t('The chat has been closed'),
      END_THE_CHAT: t.t('Terminate the chat'),
      LEAVE_CHAT: t.t('Leave the Chat'),
      POST_A_MESSAGE_TO_EVERYONE: t.t('Post a message to everyone'),
    },
    luser: Store.luser,
    endRedirectUrl: Store.chat.endRedirectUrl
  };
})

export default class ConnectedUserMenu extends React.Component {
  toggleMenu(state, e) {
    this.props.dispatch(toggleMenu(state));
  }

  handdleToggleInsiderForm() {
    this.props.mobilePanelChange('insider_form');
  }

  handdleEndChat() {
    if (window.confirm(this.props.labels.ARE_YOU_SURE_CLOSE_THE_CHAT)) {
      this.props.dispatch(EndTheChat());
    }
  }

  handdleQuitChat() {
    if (window.confirm(this.props.labels.ARE_YOU_SURE_LEAVE)) {
      window.location = this.props.endRedirectUrl;
      this.props.dispatch(closeUI());
      this.props.dispatch(notification(this.props.labels.CHAT_HAS_BEEN_CLOSED));
    }
  }

  render() {
    const itemClass = ClassNames({
      'luser': true,
      'opened': this.props.luser.menu_opened
    });

    if (!this.props.luser) {
      return (
        <div></div>
      );
    }

    return (
      <div className={itemClass}
        onClick={this.toggleMenu.bind(this)}
        // onMouseOut={this.toggleMenu.bind(this, false)}
        // onMouseOver={this.toggleMenu.bind(this, true)}
      >
        <div className='menu'>
          <span className='label'>
            <span className='caret brandedColor_color'>‸</span>
            <span className='name'>{this.props.luser.name}</span>
            <span className='clear'></span>
          </span>
        </div>
        <div className='picture fright'>
          <DomUserPicture user={this.props.luser} isInsider={false} size='xs' />
        </div>
        <ul className='dropdown'>
          {
            (() => {
              if (this.props.luser.insider) {
                return <li onClick={this.handdleToggleInsiderForm.bind(this)}>{this.props.labels.POST_A_MESSAGE_TO_EVERYONE}</li>
              }
            })()
          }
          {
            (() => {
              if (this.props.luser.insider) {
                return <li onClick={this.handdleEndChat.bind(this)}><i className="pe-7s-attention"></i>{this.props.labels.END_THE_CHAT}</li>
              }
            })()
          }
          <li onClick={this.handdleQuitChat.bind(this)}>{this.props.labels.LEAVE_CHAT}</li>
        </ul>
        <div className='clear'></div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/ConnectedUserMenu.jsx